module.exports = __webpack_public_path__ + "img/win_icon.23f17913.svg";